module.exports = __webpack_public_path__ + "static/mielikki-symbol-DND3_FnP-9a1076dce198c4441e14c6fea00fe786.webp";